import type { UI } from '@/v2/types';
import styled from '@emotion/styled';
import { Icon, Text } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

import useToggle from '@shared/v2/hooks/useToggle';

import NakedButton from '@/components/LinkButton/LinkButton';
import InclusionsList from '@/v2/components/ui/Inclusions';

export type InclusionsProps = {
  offer: UI.RoomOptionOffer;
};

const ExpandButton = styled(NakedButton)`
  display: flex;
  align-items: center;
  gap: 0.25rem;

  :focus {
    outline: none;
  }

  :focus-visible {
    outline: 2px solid ${themeGet('colors.brand.secondary')};
  }
`;

const ExpandIcon = styled(Icon)`
  transition: transform 0.2s ease-in-out;
  ${(props: { isExpanded: boolean }) =>
    props.isExpanded && `transform: rotate(180deg);`}
`;

const DEFAULT_INCLUSION_COUNT = 4;

const Inclusions = ({ offer }: InclusionsProps) => {
  const { toggle, value: isExpanded } = useToggle(false);

  const { hotelOffer, leadInOffer } = offer;
  const isLeadInOffer = !!leadInOffer;
  const inclusions = isLeadInOffer
    ? leadInOffer?.inclusions
    : hotelOffer?.inclusions;

  // Lead in offer => always 4, normal offer => 4 unless expanded then show all
  const numInclusionsToShow =
    leadInOffer || !isExpanded ? DEFAULT_INCLUSION_COUNT : Infinity;

  const showExpandButton =
    isExpanded ||
    (!isLeadInOffer && inclusions?.length > DEFAULT_INCLUSION_COUNT);

  return (
    <>
      <InclusionsList
        inclusions={inclusions}
        numberToShow={numInclusionsToShow}
        includeAndMoreText={isLeadInOffer}
      />
      {showExpandButton && (
        <ExpandButton onClick={toggle}>
          <Text
            fontSize="sm"
            lineHeight="27px"
            fontWeight="bold"
            color="brand.primary"
          >
            {isExpanded ? 'Show less' : 'Show more '}
          </Text>
          <ExpandIcon
            color="brand.primary"
            isExpanded={isExpanded}
            name="expandMore"
          />
        </ExpandButton>
      )}
    </>
  );
};

export default Inclusions;
